export default theme => ({
  root: {},
  form: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  group: {
    flexGrow: 1,
    padding: theme.spacing(2)
  },
  groupLabel: {
    paddingLeft: theme.spacing(2)
  },
  field: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    width: '320px',
    maxWidth: '100%',
    marginRight: theme.spacing(3)
  },
  portletFooter: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardButton: {
    display: "block",
    textAlign: "initial",
  },
  cardInfo: {
    //backgroundColor: theme.palette.background.default,
    width: "100%",
    textAlign: "left"
  },
  cardInfoSend: {
    //backgroundColor: theme.palette.background.default,
    width: "55%",
    textAlign: "left"
  },
  formControl: {
    //margin: theme.spacing.unit * 2,
    minWidth: 120,
    width: '100%',
  },
  textField: {
    //width: '100%',
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    color: 'orange',
  },
  /*icon: {
    color: theme.palette.success.main,
    marginLeft: theme.spacing(1),
    //opacity: 0.2,
    width: '1,5rem',
    height: '1,5rem',
    fontSize: '1,5rem'
  },*/
  btnDeleted: {
    display: 'flex',
    flexWrap: 'wrap',
    //marginLeft: '-20px',
    marginTop: '20px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
  },
  icon: {
    fontSize: 20,
    marginLeft: theme.spacing(1),
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
  },
  snackContent: {
    backgroundColor: theme.palette.error.dark,
  },
  snackContentOk: {
    backgroundColor: theme.palette.success.main,
  },
});
